<script>
import {toCurrency} from "@/global/Helpers";

export default {
  name: "TotalBreakdown",
  props: {
    breakdown: Object,
  },
  computed: {
    getRemainingCredit() {
      let finalBalance = this.breakdown.subtotal + this.breakdown.credit;
      return finalBalance < 0 ? finalBalance*-1 : 0
    }
  },
  methods: {
    formatCurrency(value) {
      return toCurrency(value);
    }
  }
}
</script>

<template>
  <div class="unit-breakdown-container">
<!--    <div class="unit-breakdown-container__title">Total</div>-->
    <div class="breakdown-box">
      <div class="breakdown-box__row" v-if="breakdown.credit < 0">
        <div class="breakdown-box__label">Subtotal:</div>
        <div class="breakdown-box__value">{{ formatCurrency(breakdown.subtotal) }}</div>
      </div>
      <div class="breakdown-box__row" v-if="breakdown.credit < 0">
        <div class="breakdown-box__label">Available Credit:</div>
        <div class="breakdown-box__value">{{ formatCurrency(breakdown.credit) }}</div>
      </div>
      <div class="breakdown-box__row breakdown-box__row--bold">
        <div class="breakdown-box__label">Contract Total:</div>
        <div class="breakdown-box__value">{{ formatCurrency(breakdown.total) }}</div>
      </div>
      <div class="breakdown-box__row breakdown-box__row--bold" v-if="breakdown.total === 0 && breakdown.credit < 0">
        <div class="breakdown-box__label">Remaining Credit:</div>
        <div class="breakdown-box__value">{{ formatCurrency(getRemainingCredit)}}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.unit-breakdown-container {
  padding: 1em 0 0 0;
  &__title {
    text-align: center;

    color: $dark-grey;
    font-size: 18px;
    font-weight: bold;
    line-height: 22px;
    margin-top: 15px;
  }
}

.breakdown-box {
  background-color: $lightest-grey;
  padding: 8px 15px 13px 15px;
  &__row {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;

    &--bold {
      font-weight: bold;
      line-height: 16px;
    }
  }

  &__row:first-of-type {
    margin-top: 0;
  }

  &__label,
  &__value {
    font-size: 14px;
    line-height: 18px;
    color: $black;
  }
}
</style>
